import { useSelector } from 'react-redux'
import { HtmlParser } from '@calendly/html-parser'
import { BodyText } from '@calendly/ui/components/typography'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'

import { useI18n } from 'locales'
import { isEmbeddedSelector } from 'selectors/embed'
import { emailSelector } from 'selectors/invitee'
import { customDomainSelector } from 'selectors/custom_domain'

import {
  Container,
  Title,
  Form,
  Input,
  Submit,
  StandardEmailInput,
  StandardSubmitButton,
  StandardSignupForm,
  StyledText,
  Subtext
} from './styles'

const PollsForm = ({ className, isEmbedded, email }) => {
  const { i18n } = useI18n()
  return (
    <Container className={className} data-component="polls-form">
      <Title>{HtmlParser(i18n.t('booking.templates.signup_form.polls_header'), { StyledText })}</Title>
      <BodyText size="medium" color={colorTextSecondary}>{i18n.t('booking.templates.signup_form.polls_subtitle')}</BodyText>
      <Form noValidate method="POST" action="/app/signup" target={isEmbedded ? '_blank' : '_self'} rel="opener">
        <Input aria-label={i18n.t('booking.templates.email')} type="email" name="email" defaultValue={email} />
        <input type="hidden" name="section" value="booking" />
        <Submit type="submit">{i18n.t('booking.templates.signup_form.button')}</Submit>
      </Form>
    </Container>
  )
}

const NonPollsForm = ({ className, isEmbedded, email }) => {
  const { i18n } = useI18n()
  const { default_domain: defaultDomain } = useSelector(customDomainSelector)

  return (
    <Container className={className} data-component="non-polls-form">
      <Title>{i18n.t('booking.templates.signup_form.header')}</Title>
      <StandardSignupForm
        noValidate
        method="GET"
        action={`${defaultDomain || ''}/app/signup`}
        target={isEmbedded ? '_blank' : '_self'}
        rel="opener"
      >
        <StandardEmailInput
          aria-label={i18n.t('booking.templates.email')}
          type="email"
          name="email"
          autoComplete="email"
          placeholder={i18n.t('booking.templates.signup_form.enter_your_email')}
          defaultValue={email}
        />
        <input type="hidden" name="section" value="booking" />
        <StandardSubmitButton type="submit">
          {i18n.t('booking.templates.signup_form.sign_up_free')}
        </StandardSubmitButton>
      </StandardSignupForm>
      <Subtext>{i18n.t('booking.templates.signup_form.no_credit_card_required')}</Subtext>
    </Container>
  )
}

const Signup = ({ className, isPoll }) => {
  const props = {
    isEmbedded: useSelector(isEmbeddedSelector),
    email: useSelector(emailSelector),
    className
  }
  return isPoll ? <PollsForm {...props} /> : <NonPollsForm {...props} />
}

export default Signup
